<script>
import { Article } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Article',
      addRoute: { name: 'Add Article' },
      verboseName: 'Article',
      verboseNamePlural: 'Articles',
      listFields: [
        { prop: 'id', label: 'id', width: 80, sortable: true },
        {
          prop: 'publication_date',
          label: 'publication date',
          sortable: true
        },
        { prop: 'title_en', label: 'title (en)', sortable: true },
        { prop: 'title_de', label: 'title (de)', sortable: true },
        { prop: 'slug_en', label: 'slug (en)', sortable: true },
        { prop: 'slug_de', label: 'slug (de)', sortable: true }
      ]
    }
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
